let encryptionConfig;
/**
 * Configures the encryption function
 *
 * Cloud-side, this must be called before any invocation and provide the functions
 * that will be used to fetch data and decrypt it. Client-side, this will be called
 * automatically once a user is logged in.
 */

const initEncryptionConfig = ({
  encryptData,
  decryptData,
  getValueOnce
}) => {
  encryptionConfig = {
    encryptData,
    decryptData,
    getValueOnce
  };
};

export { encryptionConfig, initEncryptionConfig };
